import { MAX_NUMBER_OF_CHORDS } from '../const/limits';
import { useAppSelector } from '../global/hooks';
import { selectSectionById } from '../store/sectionsSlice';
import { Id } from '../types';

export default function useHasExceededChordLimit(sectionId: Id) {
	const section = useAppSelector(selectSectionById(sectionId));
	const chordLength = section?.chords?.length ?? 0;
	return chordLength >= MAX_NUMBER_OF_CHORDS;
}
